import { css } from "@emotion/react";
import React from "react";
import { NavLink, useMatch, useResolvedPath } from "react-router-dom";
import { useAccountID } from "../store/account";
import { useShow, useShowID } from "../store/show";

const items = show =>
    [
        { label: "Show Info", path: "", end: true },
        { label: "Feeds", path: "feeds", end: true },
        { label: "Feed Mirroring", path: "feed-services", end: true, hidden: !show.hostingEnabled },
        { label: "Measurement", path: "measurement", end: true, hidden: show.youTubeShow },
        { label: "YouTube Channel", path: "youtube", end: true, hidden: !show.youTubeShow }
    ].filter(i => !i.hidden);

export default function ShowSettingsMenu() {
    const accountID = useAccountID();
    const showID = useShowID();
    const { data: show = {} } = useShow(accountID, showID);
    return (
        <div style={{ width: "14rem", flexShrink: 0 }}>
            <h1>Show Settings</h1>
            <ul
                css={css`
                    margin: 0;
                    padding: 0;
                    list-style: none;
                    font-weight: 300;
                    font-size: 0.75rem;
                    & a {
                        color: #666;
                        display: block;
                        text-decoration: none;
                        padding: 0.5rem;
                        border-bottom: 1px solid #ddd;
                        //border-left: 1px solid #ddd;
                        //border-right: 1px solid #ddd;
                    }
                    & > li {
                        background: #eee;
                        &:hover {
                            background: #f3f3f3;
                        }
                    }
                    & > li:first-of-type > a {
                        border-top: 1px solid #ddd;
                    }
                    & > li.active {
                        font-weight: 600;
                        background: #fafafa;
                        & > a {
                        }
                    }
                `}
            >
                {items(show).map(i => (
                    <MenuItem key={i.path} path={i.path} end={i.end}>
                        {i.label}
                    </MenuItem>
                ))}
            </ul>
        </div>
    );
}

function MenuItem({ path, end, children }) {
    const resolved = useResolvedPath(path);
    const active = useMatch({ path: resolved.pathname, end });
    return (
        <li className={active ? "active" : null}>
            <NavLink to={path}>{children}</NavLink>
        </li>
    );
}
